import { render, staticRenderFns } from "./HelpDeskTechnicianRequests.vue?vue&type=template&id=18123e34&scoped=true&"
import script from "./HelpDeskTechnicianRequests.vue?vue&type=script&lang=js&"
export * from "./HelpDeskTechnicianRequests.vue?vue&type=script&lang=js&"
import style0 from "./HelpDeskTechnicianRequests.vue?vue&type=style&index=0&id=18123e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18123e34",
  null
  
)

export default component.exports